export abstract class UnistocksPermissions {
  private static readonly Prefix = 'UnifyStocks';

  public static readonly DashboardGroup = this.Prefix + '.Dashboard';
  public static readonly TenantDashboard = this.DashboardGroup + '.Tenant';
  public static readonly HostDashboard = this.DashboardGroup + '.Host';

  public static readonly Portfolio = this.Prefix + '.Portfolio';
  public static readonly Watchlist = this.Prefix + '.Watchlist';
  public static readonly SavingsGoal = this.Prefix + '.SavingsGoal';

  private static readonly TenantManagementGroup = 'AbpTenantManagement';
  public static readonly TenantManagement = this.TenantManagementGroup + '.Tenants';
  public static readonly TenantManagementCreate = this.TenantManagement + '.Create';
  public static readonly TenantManagementDelete = this.TenantManagement + '.Delete';
  public static readonly TenantManagementUpdate = this.TenantManagement + '.Update';
  public static readonly TenantManagementFeatures = this.TenantManagement + '.ManageFeatures';
  public static readonly TenantManagementImpersonation = this.TenantManagement + '.Impersonation';

  private static readonly IdentityGroup = 'AbpIdentity';
  public static readonly UserManagement = this.IdentityGroup + '.Users';
  public static readonly UserManagementCreate = this.UserManagement + '.Create';
  public static readonly UserManagementDelete = this.UserManagement + '.Delete';
  public static readonly UserManagementUpdate = this.UserManagement + '.Update';
  public static readonly UserManagementPermissions = this.UserManagement + '.ManagePermissions';
  public static readonly UserManagementRoles = this.UserManagementUpdate + '.ManageRoles';

  public static readonly Roles = 'AbpIdentity.Roles';
  public static readonly RolesCreate = 'AbpIdentity.Roles.Create';
  public static readonly RolesUpdate = 'AbpIdentity.Roles.Update';
  public static readonly RolesDelete = 'AbpIdentity.Roles.Delete';
  public static readonly RolesManagePermissions = 'AbpIdentity.Roles.ManagePermissions';

  private static readonly AssetManagementGroup = this.Prefix + '.Assets';
  public static readonly AssetManagementList = this.AssetManagementGroup + '.Asset';

  private static readonly ExternalGroup = this.Prefix + '.External';
  public static readonly DataSourceManagement = this.ExternalGroup + '.DataSources';

  public static readonly SettingManagement = 'SettingManagement';
  public static readonly SettingManagementEmailing = this.SettingManagement + '.Emailing';
  public static readonly SettingManagementEmailingTest = this.SettingManagementEmailing + '.Test';
  public static readonly SettingManagementTimeZone = this.SettingManagement + '.TimeZone';
  public static readonly SettingManagementIdentity = this.SettingManagement + '.Identity';
  public static readonly SettingManagementFeatures = this.SettingManagement + '.Features';
}
